import script from "./Spinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./Spinner.vue?vue&type=script&setup=true&lang=ts"

import "./Spinner.vue?vue&type=style&index=0&id=7b6c5fe6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b6c5fe6"]])

export default __exports__